<template>
	<div class="car_preview" droppable="true" draggable="true" v-on:dragstart="dragstart" v-on:dragend="dragend" v-on:click="setEditing(car)" v-bind:class="{ active: $store.state.editingCarID == car.vorgangsnummer }">
			<div class="car_image" v-if="car.fotos_json && car.fotos_json !='' " :style="getBG(car)"></div>
			<ol class="car_data">
				<li class="car_datum">{{ getFormattedDate(car) }}</li>
				<li class="car_readby" v-if=" !car.readby "><i class="fa fa-dot-circle-o" aria-hidden="true"></i></li>
				<li class="car_marke"><span class="verkaufer">{{ car.name }}</span> {{ car.marke }} {{ car.modell }}
					<span class="car_baujahr" v-if=" car.baujahr != ''">{{ car.baujahr }}</span> &nbsp;
				</li>				
				<li class="car_verk_name" v-if=" car.verk_name != ''">{{ car.verk_name }}</li>
				<li class="car_vorgangsnummer" v-if=" car.vorgangsnummer != ''">{{ car.vorgangsnummer }} 
					<span class="car_ip" >IP: {{ car.userIP }}</span>
				</li>
<!-- 				<li><button v-on:click="deleteCar(car)" class="del"><i class="fa fa-trash-o" aria-hidden="true"></i></button></li> -->
			</ol>		
	</div>
</template>

<script>
  export default {
    props: ['car'],
    data() {
      return {
        isEditing: false,
        FormattedDate: '',
        currentDate:  new Date(),
        yesterday: (function(d){ d.setDate(d.getDate()-1); return d})(new Date),
        //cardetails: JSON.parse(this.car.car_json)
        
      };
    },
    mounted: function(){
	    //console.log('car mounted');
	    //console.log( JSON.parse(this.car.car_json ).customSubject )
	    //console.log(this.car);
	    //console.log( this.car );
    },
    methods: {
	    
/*
	  dropped: function(e){
			//e.preventDefault()
			console.log('dropped'); 
			console.log( this.$store.state.draggedCar );			
			$(e.currentTarget).removeClass(' d_over')									
	  },		
*/
	    

	  dragstart: function(e){
			//e.preventDefault()
		  //console.log(this.car);
		  //e.dataTransfer.effectAllowed = 'copy'; // only dropEffect='copy' will be dropable
		  e.dataTransfer.setData('Text', this.car.vorgangsnummer); 		  
		  this.$store.state.draggedCar = this.car;
		  //e.dataTransfer.setData('ID', 'testballon');
		  //console.log('dragstart');
	  },  

	  dragend: function(e){
		  //e.preventDefault()
		  //console.log('dragended...');
		  this.$store.state.draggedCar = false
		  //console.log( this.$store.state.draggedCar )
	  },
/*
	  dragenter: function(e){
		  console.log('enter other car');
	  },
*/

		
		
		
			  
	  
	  getBG(car){
		  if( car.fotos_json ) {
			  if( typeof car.fotos_json == 'object') { //car.fotos_json != "" && car.fotos_json.length < 2047) { 
				//var fotoss = JSON.parse( car.fotos_json );
				if( car.fotos_json.length > 0)
			  	return { 'background-image': 'url(' + car.fotos_json[0] + ') ' }
			  }
		  }
		   
		  return '';
	  }, 
	  getFormattedDate(car){
		  this.FormattedDate = car.userdate
		  var d = new Date( car.created )
		  if( d.toLocaleDateString() == this.currentDate.toLocaleDateString() )  return 'Heute, ' +car.usertime
		  if( d.toLocaleDateString() == this.yesterday.toLocaleDateString() )  return 'Gestern'
		  return this.FormattedDate
	  }, 
      completeCar(car) {
        this.$emit('complete-car', car);
      },
      deleteCar(car) {
        this.$emit('delete-car', car);
      },
      setEditing(car) {
	  	// this.$store.setEditingCar( car.id  );
	    this.$store.commit('updateEditingCarID',  car.vorgangsnummer )	    
	    //console.log( this.$store.state.editingCarID )
        //car.isEditing = true;
        //this.$emit('edit-car', car);
      },
      hideForm() {
        this.isEditing = false;
      },
    },
  };

</script>